<app-modal [modalConfig]="modalConfig" #modal>
  <ng-container *ngIf="data$ | async as data">
    <div class="modal-custom" role="dialog" aria-modal="true">
      <div (click)="$event.stopPropagation()">
        <div class="modal-content">
          <button type="button" class="close-btn" (click)="close()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="purchase-limit-icon-circle">
            <img
              class="icon img-fluid"
              alt="Warning"
              src="assets/images/icons/alert-icon-warning.png"
            />
          </div>
          <p
            class="purchase-limit-items-description"
            i18n="|Product Warning and Product Messaging PHS-10891"
          >
            We're sorry, the following item(s) on your order are
            <strong>no longer available</strong> and have been removed. Please review your updated
            order before submitting.
          </p>
          <div *ngIf="data.items?.backorderItems?.length">
            <div
              class="d-flex justify-content-center"
              *ngFor="let product of data.items.backorderItems"
            >
              <span>
                <strong class="text-primary">{{ product.description }}</strong> ({{
                  product.skuCode
                }})
              </span>
            </div>
          </div>

          <div *ngIf="data.items?.nonBackorderItems?.length">
            <div
              class="d-flex justify-content-center"
              *ngFor="let product of data.items.nonBackorderItems"
            >
              <span>
                <strong class="text-primary">{{ product.description }}</strong> ({{
                  product.skuCode
                }})
              </span>
            </div>
          </div>

          <div class="qty-btn-wrapper mt-3">
            <button type="button" class="qty-btn-ok" (click)="ok()" i18n>Ok</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</app-modal>
